import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-reminder-input',
  templateUrl: './reminder-input.component.html',
  styleUrls: ['./reminder-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ReminderInputComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ReminderInputComponent),
      multi: true,
    },
  ],
})
export class ReminderInputComponent implements OnInit, ControlValueAccessor, Validator {

  @Input() minDate!: Date;
  @Input() maxDate!: Date;

  value = {
    reminder: false,
    date: null,
    time: this.setTimeToGivenHours(0), // Default time at 00:00
  };

  onChange = (value: any) => {};
  onTouched = () => {};

  constructor() {}

  ngOnInit() {}

  writeValue(value: any): void {
    if (value) {
      this.value = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}

  onToggleChange() {
    this.onChange(this.value);
    this.onTouched();
  }

  onDateChange(date: any) {
    this.value.date = date;
    this.onChange(this.value);
    this.onTouched();
  }

  onTimeChange(time: Date) {
    this.value.time = time;
    this.onChange(this.value);
    this.onTouched();
  }

  setTimeToGivenHours(hours: number): Date {
    const updatedDate = new Date();
    updatedDate.setHours(hours, 0, 0, 0);
    return updatedDate;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (this.value.reminder && !this.value.date) {
      return { requiredDate: true }; // Validation error if date is not set
    }
    return null;
  }
}
